// Auth store — JWT access token + current user.
//
// Persisted to localStorage so reload doesn't kick the user back to /login.
// The api/client.ts reads `getState().token` on every request via getAuthToken
// so token rotation (re-login) is picked up without re-instantiating the client.

import { create } from "zustand";
import { persist } from "zustand/middleware";

import type { MeResponse } from "@incorposano/api-client";

interface AuthState {
  token: string | null;
  user: MeResponse | null;

  loginSuccess(args: { token: string; user: MeResponse }): void;
  setUser(user: MeResponse): void;
  logout(): void;
}

export const useAuth = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      user: null,

      loginSuccess: ({ token, user }) => set({ token, user }),
      setUser: (user) => set({ user }),
      logout: () => set({ token: null, user: null }),
    }),
    {
      name: "ics-auth",
      partialize: (s) => ({ token: s.token, user: s.user }),
    },
  ),
);
